module.exports = __webpack_public_path__ + "fonts/SFUIText-RegularItalic.2fc8d6cb.woff";